let config = {
    apiBaseUrl: process.env.REACT_APP_BASE_PROTOCOL + "://" + process.env.REACT_APP_API_BASE_URL,
    deployment: process.env.REACT_APP_DEPLOYMENT,
    isPetroff: process.env.REACT_APP_DEPLOYMENT === 'petroff',
    idleTimeoutInMilliseconds: 1 * 60 * 60 * 1000 // 1 Hour in milliseconds
};

export default config;